/**
 * Global busy registry for user-initiated (button-triggered) requests.
 *
 * Requests are tracked as a stack of tokens so overlapping calls never clear
 * each other's overlay — the overlay stays up until the last one finishes and
 * always shows the most recently started message.
 */

/** Standard note for spans the user must not interrupt (payment, order writes). */
export const DO_NOT_CLOSE = "Please do not close or refresh this page.";

let entries = [];
let nextToken = 0;
const listeners = new Set();

const snapshotOf = (list) =>
  list.length === 0 ? null : list[list.length - 1];

let snapshot = null;

const notify = () => {
  snapshot = snapshotOf(entries);
  listeners.forEach((listener) => listener());
};

export const pushBusy = (message, note) => {
  nextToken += 1;
  const token = nextToken;
  entries = [...entries, { token, message, note: note || null }];
  notify();
  return token;
};

export const popBusy = (token) => {
  if (token == null) return;
  const next = entries.filter((entry) => entry.token !== token);
  if (next.length === entries.length) return;
  entries = next;
  notify();
};

export const subscribeBusy = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getBusySnapshot = () => snapshot;
